import { AxiosResponse } from 'axios';
import api from './api';
import Category from '../models/Category/Category';
import { PaginationLinks, PaginationMeta } from '../models/Paginator';

type CategoryCreateRequest = Omit<Category, 'id'>;

export interface CategoriesResponse {
  data: Category[]
  meta: PaginationMeta
  links: PaginationLinks
}

export const get = async (page?: number): Promise<AxiosResponse<CategoriesResponse>> => {
  const params = page ? { page } : {};

  return api.get<CategoriesResponse>('v1/categories', { params });
};

export const post = async (data: CategoryCreateRequest): Promise<AxiosResponse<string>> => api.post<string>('v1/categories/create', data);

export const put = async (data: Category) => api.post(`v1/categories/${data.id}/update`, data);

export const destroy = async (id: string) => api.post(`v1/categories/${id}/delete`, {});

export const getLastOrderNumber = async (): Promise<AxiosResponse<number>> => api.get<number>('v1/categories/last-order-number');

export default {
  get,
  post,
  put,
  destroy,
  getLastOrderNumber,
};
